export enum InputMaskEnum {
  UsaPhone = "(###) ###-####",
  BrazilPhone = "(##) #####-####",
  Date = "##/##/####",
  CPF = "###.###.###-##",
  CNPJ = "##.###.###/####-##",
  ZipCode = "#####-###",
  CreditCard = "#### #### #### ####",
}
